import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { claimsList, getTags, claimsCustomer } from './request';
import tagModel from '@/components/tagModel.vue';
import tagList from '@/components/tagList.vue';
import clickShowTag from '@/components/clickShowTag.vue';
import { mapState } from 'vuex';
export default {
  components: {
    clickShowTag,
    tagModel,
    tagList
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  data() {
    return {
      tagShow: false,
      tagData: [],
      tagList: [],
      form: {
        type: 'groupInsuranceAll',
        customerId: undefined
      },
      data: [],
      columns: [
      // {
      //   slots: {title: '标签'},
      //   dataIndex: 'tag',
      //   key: '0',
      //   align: 'center',
      //   scopedSlots: {customRender: 'tag'},
      //   width: 80
      // },
      {
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80
      }, {
        slots: {
          title: '审核流Id'
        },
        dataIndex: 'id',
        key: '1',
        align: 'center',
        width: 80
      }, {
        slots: {
          title: '保单号'
        },
        dataIndex: 'policyNo',
        key: '2',
        align: 'center',
        width: 200
      }, {
        slots: {
          title: '产品名称'
        },
        dataIndex: 'insuranceName',
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'insuranceName'
        }
      }, {
        slots: {
          title: '保单归属'
        },
        dataIndex: 'customerName',
        key: '4',
        align: 'center'
      },
      // {title: '出单组织',  dataIndex: 'structureName', key: '3',align: 'center'},
      {
        slots: {
          title: '申请人'
        },
        dataIndex: 'userName',
        key: '7',
        align: 'center'
      }, {
        slots: {
          title: '申请时间'
        },
        dataIndex: 'createAt',
        key: '8',
        align: 'center',
        width: 180
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '3',
        align: 'center',
        width: 180
      }, {
        slots: {
          title: '审核状态'
        },
        dataIndex: 'status',
        key: '10',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        key: '9',
        align: 'center',
        width: 200
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      customerList: [],
      applicationList: []
    };
  },
  created() {
    if (this.accountInfo.tag == 0) {
      //   this.getTagsFun();
      this.getDataFun();
    } else {
      claimsCustomer({}).then(res => {
        this.customerList = res;
        if (res.length == 0) {
          return false;
        }
        let arr = res.filter(item => item.id == Number(sessionStorage.getItem('examineCustomer')));
        this.form.customerId = arr.length != 0 ? Number(sessionStorage.getItem('examineCustomer')) : res[0].id;
        // this.getTagsFun();
        this.getDataFun();
      });
    }
  },
  methods: {
    getTagsFun() {
      let parameter = {};
      this.tagData = [];
      this.tagList = [];
      if (this.accountInfo.tag != 0) {
        if (!this.form.customerId) {
          return false;
        }
        parameter = {
          customerId: this.form.customerId
        };
        sessionStorage.setItem('examineCustomer', this.form.customerId);
      }
      getTags(parameter).then(res => {
        this.tagData = res;
      });
      this.searchFun();
    },
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      claimsList(obj).then(res => {
        console.log(res);
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleSee(val) {
      this.processShow = true;
      this.$nextTick(() => {
        this.$refs.processFrom.init(val);
      });
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    tagOk(arr, arr2, arrVaule) {
      this.form.tags = arrVaule;
      this.tagList = arr;
      console.log(arr, arr2, arrVaule);
      if (arr2.length != 0) {
        this.tagList.push(arr2);
      }
      this.searchFun();
    },
    tagListOk(arr, arr2, arrVaule) {
      this.tagData = arr;
      this.tagList = arr2;
      this.form.tags = arrVaule;
      this.searchFun();
    },
    tagClickFun() {
      if (this.tagData.length == 0) {
        return this.$message.error(this.$t('该保单归属人暂无可查询的标签'));
      }
      this.tagShow = true;
    },
    onDateChange(date, dateString) {
      this.form.createAt = this.form.createAt ? this.form.createAt : '';
    }
  }
};